import React, { memo, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useSetRecoilState } from 'recoil'
import { AnimatePresence } from 'framer-motion'
import CustomScroller from 'react-custom-scroller'

import { Close } from '../../assets/svg/icons'

import {
  selectedClient as selectedClientState
} from '../../store/uiStore'

import { ClientModalWrapper, ClientModalContainer, ClientModalInner, ClientModalLogo, ClientModalDesc } from '../../styles/clientsStyles'

const ClientsModal = ({ isActive, client }) => {
  const setSelectedClient = useSetRecoilState(selectedClientState)

  const cmodalScroller = useRef(null)

  const handleCloseClient = () => {
    setSelectedClient((last) => '')
  }

  useEffect(() => {
    if ( isActive ) {
      cmodalScroller.current.scrollTop = 0
    }
  }, [isActive])

  return (
    <AnimatePresence exitBeforeEnter>
      {isActive && (
        <ClientModalWrapper
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
            transition: {
              delay: 0.5,
              duration: 0.5
            }
          }}
          transition={{
            duration: 0.5,
            ease: 'easeOut'
          }}
        >
          <ClientModalContainer
            initial={{
              y: '100%',
              opacity: 0,
            }}
            animate={{
              y: 0,
              opacity: 1,
            }}
            exit={{
              y: '-100%',
              opacity: 0,
              transition: {
                delay: 0,
                duration: 0.5
              }
            }}
            transition={{
              delay: 0.5,
              duration: 0.5,
              ease: 'easeOut'
            }}
          >
            <CustomScroller ref={cmodalScroller} className='Scroller' innerClassName='ScrollerContent'>
              <ClientModalInner>
                <button
                  onClick={() => handleCloseClient()}
                >
                  <Close />
                </button>
                <ClientModalLogo>
                  <img src={client.logo} alt={client.name} />
                </ClientModalLogo>
                <h3>{client.name}</h3>
                <ClientModalDesc dangerouslySetInnerHTML={{__html: client.description}} />
              </ClientModalInner>
            </CustomScroller>
          </ClientModalContainer>
        </ClientModalWrapper>
      )}
    </AnimatePresence>
  )
}

ClientsModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  client: PropTypes.object.isRequired
}

export default memo(ClientsModal)
